// *************************** Import CSS *************************** //

import "./meal-prep-banner.css";

// *************************** Import Images *************************** //

import "/src/assets/menu-icons/stacked-food-containers.svg"
import "/src/assets/menu-icons/food-delivery-truck.svg"
import "/src/assets/menu-icons/fork-knife-2.svg"

export const homepageBanner = 1;

// *************************************************** Insert Banner **************************************************** //

class MealPrepBanner extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `

	<!-- *********************************** BEGIN: BANNER CODE ************************************** --> 

 	<div class="container-fluid">

	<!-- BEGIN: Smaller-Devices Announcement Banner Row -->

      <div class="banner-smaller-devices text-center pb-3">

	        <p class="col-12 banner-text sans-serif-heading text-white text-size-h2 bold pt-2 pb-2 mb-0">

            INTRODUCING</br>New Jack Swing Meal Prep</br>

            &mdash; Hefty &#38; Healthy Meals &mdash;

            </br>

            Delivered To Your Door&excl; 
          
          </p>
        
          <a href="meal-prep-menu.html">
            <button id="meal-prep-button" type="button" class="btn-blue bold drop-shadow">CHECK IT OUT</button>
          </a>

      </div>

    <!-- END: Smaller-Devices Announcement Banner Row -->



    <!-- BEGIN: Medium-Devices Announcement Banner Row -->

      <div class="banner-medium-devices text-center pb-3">

          <p class="col-12 banner-text sans-serif-heading text-white text-size-h2 bold pt-2 pb-2 pb-md-0 pb-lg-2 mb-0">

            INTRODUCING&colon; New Jack Swing Meal Prep</br>

            <span class="banner-icon-1">
              <img src="stacked-food-containers.svg" />
            </span>

            Hefty &#38; Healthy Meals Delivered To Your Door&excl; 

            <span class="banner-icon-2">
              <img src="food-delivery-truck.svg" />
            </span>
          
          </p>
        
          <a href="meal-prep-menu.html">
            <button id="meal-prep-button" type="button" class="btn-blue bold drop-shadow">CHECK IT OUT</button>
          </a>

      </div>

    <!-- END: Medium-Devices Announcement Banner Row -->



    <!-- BEGIN: Larger-Devices Announcement Banner Row -->

      <div class="banner-large-devices">

        <div class="col-12 text-center pt-0">

          <p class="banner-text serif-heading text-white text-size-h2 bold py-1 mb-0">
                
            INTRODUCING 

            <span class="banner-icon-1">
              <img src="stacked-food-containers.svg" />
            </span>

            New Jack Swing Meal Prep

            <span class="banner-icon-2">
              <img src="food-delivery-truck.svg" />
            </span>
                
            We Deliver Hefty &#38; Healthy Meals To Your Door &nbsp;
                
              <a href="meal-prep-menu.html">
                <button id="meal-prep-button" type="button" class="btn-blue bold drop-shadow">CHECK IT OUT&excl;</button>
              </a>
              
          </p>
            
        </div>

      </div>

    <!-- END: Larger-Devices Announcement Banner Row -->

   </div>

<!-- *********************************** END: BANNER CODE ************************************** --> 

    `
  }
}


// *********************** Define 'extends HTMLElements' Above *********************** //

customElements.define('meal-prep-banner', MealPrepBanner);